
class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.backgroundCloseModal = this.backgroundCloseModal.bind(this);
        this.escCloseModal = this.escCloseModal.bind(this);
        this.modalRef = React.createRef();
        //Keep an internal state to track if open
        this.state = {
            open: this.props.open || false,
            trapped: false
        };
        //Placeholder for focus trap
        this.trapHandler;
    }

    static propTypes = {
        open: PropTypes.bool.isRequired,
        labelledby: PropTypes.string.isRequired,
        backgroundClose: PropTypes.bool,
        escClose: PropTypes.bool,
        handleOpen: PropTypes.func,
        handleClose: PropTypes.func,
        classes: PropTypes.string,
        headerText: PropTypes.string,
        actions: PropTypes.array
    }

    static defaultProps = {
        open: false,
        backgroundClose: true,
        escClose: true,
        headerText: " ",
        classes: "modal--flat modal--large"
    }

    componentDidMount() {
        // Bind keydown
        document.onkeydown = (event) => {
            //console.log('keydown binding')
            event = event || window.event;
            let isEscape = false;
            if ("key" in event) {
                isEscape = (event.key === "Escape" || event.key === "Esc");
            } else {
                isEscape = (event.keyCode === 27);
            }
            if (isEscape) {
                this.escCloseModal();
            }
        }
    }

    componentDidUpdate() {
        //Trap Focus and Release
        //TODO: replace with reliable module reference. Global assumption fragile
        // Can cause weird edge cases and break alertify prompts. Test your modals!
        // if(typeof ally !== "undefined"){
        //     if(this.props.open){
        //         this.trapHandler = ally.maintain.disabled({
        //             filter: document.querySelectorAll('.modal.is-open, .dz-hidden-input, .ok, .cancel, .alertify button').push(this.modalRef.current)
        //         });
        //         this.modalRef.current.focus();
        //     } else if(!this.props.open && this.trapHandler != null){
        //         this.trapHandler.disengage();
        //     }
        // }

        if(this.props.open){
            focusTrapEngage({
                context: this.modalRef.current
            })
            this.modalRef.current.focus();
        } else if(!this.props.open && this.trapHandler != null){
            focusTrapDisengage();
        }
    }

    // currently openModal isn't used? Relying on props passed in from parent component?
    openModal() {
        this.setState({ open: true });
        //Handle prop callback
        if(this.props.handleOpen){
            this.props.handleOpen();
        }
        this.modalRef.current.focus();
    }

    closeModal() {
        this.setState({ open: false });
        //Handle prop callback
        if(this.props.handleClose){
            this.props.handleClose();
        }
    }

    backgroundCloseModal() {
        if(this.props.backgroundClose) {
            this.setState({ open: false });
            //Handle prop callback
            if(this.props.handleClose){
                this.props.handleClose();
            }
        }
    }

    escCloseModal() {
        if(this.props.escClose) {
            this.setState({ open: false });
            // if(typeof ally !== "undefined" && this.trapHandler != null){
            //     console.log('esc close', this.trapHandler)
            //     this.trapHandler.disengage();
            // }

            focusTrapDisengage();

            //Handle prop callback
            if(this.props.handleClose){
                this.props.handleClose();
            }
        }
    }

    render() {
        // console.log("Props: ", this.props);
        let classes = "modal " + this.props.classes;
        let hidden = "true";
        if (this.props.open) {
            classes += " is-open";
            hidden = "false";
        }
        let modalActions = false;
        if (this.props.actions && this.props.actions.length > 0){
            modalActions = this.props.actions.map((action,index) =>
                <Button classes={"button--loose " + action.classes} onClick={action.onClick} key={"modal_action_" + index}>{action.label}</Button>
            );
        }
        return (
            <div className={classes} id={"modal_for_" + this.props.labelledby} aria-labelledby={this.props.labelledby} role="dialog" tabIndex="-1" aria-hidden={hidden} ref={this.modalRef}>
                <div className="modal-close--background" onClick={this.backgroundCloseModal}></div>
                <div className="modal-container">
                    <div className="modal-header">
                        {this.props.headerText}
                        <button className="modal-close" title="Close Modal" onClick={this.closeModal}>×</button>
                    </div>
                    <div className="modal-body">
                        {this.props.children}
                    </div>
                    {modalActions && (
                        <div className="modal-footer">
                            {modalActions}
                        </div>
                    )}

                </div>
            </div>
        );
    }
}
